import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { getUserNip } from '../../../../utils/adminTools/getUserNip';
import { LoadingButton } from '@mui/lab';
import useWallet from '../../../../hooks/useWallet';
import { firestore } from '../../../../contexts/FirebaseContext';
import useWalletEvents from '../../../../hooks/useWalletEvents';
import useAuthUsers from '../../../../hooks/useAuthUsers';
import useCupones from '../../../../hooks/cuponesDescuentos/useCupones';

function DialogConfirmCancelarEnvio({ data, dataAdmin, dialogProp }) {
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <Box>
      <Button
        variant={dialogProp ? dialogProp?.variant || 'contained' : 'contained'}
        size={dialogProp ? dialogProp?.size : 'medium'}
        color={dialogProp ? dialogProp?.color : 'error'}
        onClick={() => setOpenDialog(true)}
      >
        Confirmar cancelacion
      </Button>
      <DialogConfirmCancerlar open={openDialog} onClose={setOpenDialog} dataEnvio={data} adminId={dataAdmin?.id} />
    </Box>
  );
}

export default DialogConfirmCancelarEnvio;

function DialogConfirmCancerlar({ open, onClose, dataEnvio, adminId }) {
  const [loading, setLoading] = useState(false);
  const [cancelationType, setCancelationType] = useState('completa');
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [formData, setFormData] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();
  const { handleWalletEvent } = useWalletEvents();
  const { verifyUserNip } = useAuthUsers();
  const { restaurarCupon } = useCupones();

  const handleClose = () => {
    reset();
    onClose(false);
  };

  console.log({ formData });
  const handleCancel = () => {
    setConfirmDialog(false);
  };

  //   setLoading(true);
  //   let userNip;
  //   try {
  //     userNip = await getUserNip(adminId);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //     enqueueSnackbar('Se ha producido un error al obtener el nip', { variant: 'error' });
  //   }

  //   if (verifyUserNip(dataForm.nip)) {
  //     await firestore.collection('cotizaciones').doc(dataEnvio?.id).update({ state: 'CANCELADO', status: 'CANCELADO' });

  //     const amount =
  //       cancelationType === 'completa'
  //         ? dataEnvio.shippingValue
  //         : dataEnvio.shippingValue - (dataEnvio.utilidadEnvioDagpacket + dataEnvio.utilidadEnvioLicen);

  //     const obj = {
  //       nameEvent: 'ADD',
  //       ownerUserID: dataEnvio.user_id,
  //       category_service_id: 'PAQUETERIA',
  //       amount,
  //       message: dataForm.message || 'Sin mensaje',
  //       reason: 'Envio cancelado',
  //       payment_method: 'ABONO',
  //       payment_source: 'DAGPACKET',
  //       rerport_id: '',
  //       successFuncts: [handleClose],
  //       successFunctsParams: [setLoading(false)],
  //       successSnackbar: true
  //     };

  //     await handleWalletEvent(obj);
  //     await restaurarCupon(dataEnvio);
  //   } else {
  //     setLoading(false);
  //     enqueueSnackbar('Ingrese un NIP correcto', { variant: 'error' });
  //   }
  // };
  const handleConfirm = async () => {
    setLoading(true);
    let userNip;
    try {
      userNip = await getUserNip(adminId);
    } catch (error) {
      console.log(error);
      setLoading(false);
      enqueueSnackbar('Se ha producido un error al obtener el nip', { variant: 'error' });
    }
    if (verifyUserNip(formData.nip)) {
      await firestore.collection('cotizaciones').doc(dataEnvio?.id).update({ state: 'CANCELADO', status: 'CANCELADO' });
      const amount =
        cancelationType === 'completa'
          ? dataEnvio.shippingValue
          : dataEnvio.shippingValue - (dataEnvio.utilidadEnvioDagpacket + dataEnvio.utilidadEnvioLicen);
      const obj = {
        nameEvent: 'ADD',
        ownerUserID: dataEnvio.user_id,
        category_service_id: 'PAQUETERIA',
        amount,
        message: formData.message || 'Sin mensaje',
        reason: 'Envio cancelado',
        payment_method: 'ABONO',
        payment_source: 'DAGPACKET',
        rerport_id: '',
        successFuncts: [handleClose],
        successFunctsParams: [setLoading(false)],
        successSnackbar: true
      };
      await handleWalletEvent(obj);
      await restaurarCupon(dataEnvio);
      enqueueSnackbar('Cancelación exitosa', { variant: 'success' });
    } else {
      setLoading(false);
      enqueueSnackbar('Ingrese un NIP correcto', { variant: 'error' });
    }
    setConfirmDialog(false);
  };
  const prepareCancelEnvio = (data) => {
    setFormData(data);
    setConfirmDialog(true);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="alert-dialog-title">Confirmar cancelacion del envio</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(prepareCancelEnvio)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          <Box marginBottom="15px">
            <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
            {errors.message && (
              <Typography color="error" fontSize="13px">
                Ingrese un mensaje
              </Typography>
            )}
          </Box>
          <LoadingButton
            loading={loading}
            fullWidth
            variant="contained"
            onClick={() => setCancelationType('completa')}
            type="submit"
          >
            Cancelación completa
          </LoadingButton>
          <LoadingButton
            loading={loading}
            fullWidth
            variant="contained"
            onClick={() => setCancelationType('sin_comision')}
            type="submit"
            color="secondary"
            sx={{ my: 2 }}
          >
            Cancelación sin comisión
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>

      <Dialog open={confirmDialog} onClose={handleCancel}>
        <DialogTitle id="alert-dialog-confirm-title">Confirmar Acción</DialogTitle>
        <DialogContent>
          <Typography>
            {cancelationType === 'completa' ? (
              <span>
                Esta acción cancelará el envío
                <span style={{ fontWeight: 'bold' }}> DEVOLVIENDO EL VALOR TOTAL</span> de la factura
              </span>
            ) : (
              <span>
                Esta accion cancelará el envío pero
                <span style={{ fontWeight: 'bold' }}> NO DEVOLVERÁ</span> las respectivas comisiones de la factura
              </span>
            )}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel} color="error">
            Cancelar
          </Button>
          <LoadingButton loading={loading} onClick={handleConfirm} color="success">
            Confirmar
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
}
